import { AbstractControl, UntypedFormControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { validateDoiFormat, validateDoiOrURLFormat } from './doi.validator';
import { institutionSuffix } from './institution-suffix.validator';
import { validateIssnFormat } from './issn.validator';
import { validateNumberFormat } from './number.validator';
import { orcidFormat } from './orcid.validator';
import { atLeastOneRequired } from './at-least-one-required.validator';
import { validateDateFormat } from './date-format.validator';

export class ExlValidators {
    static validatorsList(validatorName: string) {
        switch(validatorName) {
            case 'doi': return validateDoiFormat;
            case 'doiUrl': return validateDoiOrURLFormat;
            case 'issn': return validateIssnFormat;
            case 'orcid': return orcidFormat;
            case 'number': return validateNumberFormat;
            default: return null;
        }
    }

    static validateDoiFormat(control: UntypedFormControl) {
        return validateDoiFormat(control);
    }

    static validateDoiOrURLFormat(control: UntypedFormControl) {
        return  validateDoiOrURLFormat(control);
    }

    static validateIssnFormat(control: UntypedFormControl) {
        return validateIssnFormat(control);
    }

    static atLeastOneRequired(fieldNamesLists: string[][]) {
        return atLeastOneRequired(fieldNamesLists);
    }

    static institutionSuffix(institutionSuffixes: BehaviorSubject<string[]>) {
        return institutionSuffix(institutionSuffixes);
    }


    static validateNumberFormat(control: UntypedFormControl) {
        return validateNumberFormat(control);
    }

    static orcidFormat(control: UntypedFormControl) {
        return orcidFormat(control);
    }

    static validateDateFormat(dateInputFormats) {
        return validateDateFormat(dateInputFormats);
    }

    // static requiredIf(controlName: string) {
    //     return requiredIf(controlName);
    // }
}
